angular.module('iw.frontyard.signup')
    .constant('SignupReasonsForLoanChoicesDE',
        [
            {name: 'Inventory/Stock purchase', value: 'stock_purchase'},
            {name: 'Bridging loan', value: 'bridging_loan'},
            {name: 'Marketing', value: 'marketing'},
            {name: 'Equipment/buildings purchase', value: 'equipment_purchase'},
            {name: 'Pay a due bill', value: 'pay_bill'},
            {name: 'Refinancing debt', value: 'refinancing_debt'},
            {name: 'Financing client order', value: 'financing_client_order'},
            {name: 'Pay a tax bill', value: 'pay_tax_bill'},
            {name: 'Other', value: 'other'}
        ]
    );